import React, { useState, useEffect } from 'react';
import { lighten } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import {
  Avatar,
  CssBaseline,
  Box,
  IconButton,
  Container,
  Grid,
  Paper,
  Tooltip,
  Typography
} from '@mui/material';
import { Tooltip as TooltipRecharts } from 'recharts';


import InfoIcon from '@mui/icons-material/Info';
import {
  Radar, RadarChart, PolarGrid, Legend,
  PolarAngleAxis, PolarRadiusAxis,
  Label, ScatterChart, Scatter,
  XAxis, YAxis, CartesianGrid,
  LabelList
} from 'recharts';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import { indigo, pink } from '@mui/material/colors';

import Copyright from '../../components/Copyright';
import TopBar from '../../components/TopBar';
import Title from '../../components/Title';
import useStylesMain from '../../useStyles';
import DrawerMenu from '../../components/DrawerMenu';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  tableRow: {
    "&$selected, &$selected:hover": {
      backgroundColor: lighten(theme.palette.primary.light, 0.5)
    }
  },
  tableCell: {
    "$selected &": {
      color: lighten(theme.palette.primary.light, 0.5)
    }
  },
  selected: {},
  avatar_image: {
    width: "100px",
    height: "100px",
    borderRadius: "50%",
  },

  avatar_text: {
    color: "#14143c",
    backgroundColor: "white",
    padding: "3px",
    fontFamily: "Coboto",
    fontSize: 15
  }
}));


function Item(props) {
  return (
    <>
      <Avatar alt="I" src={props.img_url} className={props.style} />
    </>
  );
}

export default function CompareSellers(props) {
  const classes = useStyles();
  const classesMain = useStylesMain()
  const [data] = useState(JSON.parse(sessionStorage.getItem('selectedSellers')))
  const [dataStore] = useState(JSON.parse(sessionStorage.getItem('selectedStoreInf')))

  // let clr_plt = ["#2584A5","#F6C85E","#6F4E7B","#9DD766","#CA472E","#FA9F56","#8DDDD0"]

  const radarData = [{
    subject: 'Vendas'
  },
  {
    subject: 'Ticket'
  },
  {
    subject: 'Conversão'
  },
  {
    subject: 'PA'
  },
  {
    subject: 'Atend.'
  }]


  useEffect(() => {
    data.forEach((seller, index) => {
      radarData[0][String(seller.id)] = Number((100 * Number(seller.sales) / Number(dataStore[0].sales)).toFixed(2))
      radarData[1][String(seller.id)] = Number((100 * Number(seller.ARPPU) / Number(dataStore[0].ARPPU)).toFixed(2))
      radarData[2][String(seller.id)] = Number((100 * Number(seller.conversion) / Number(dataStore[0].conversion)).toFixed(2))
      radarData[3][String(seller.id)] = Number((100 * Number(seller.PA) / Number(dataStore[0].PA)).toFixed(2))
      radarData[4][String(seller.id)] = Number((100 * Number(seller.attendance) / Number(dataStore[0].attendance)).toFixed(2))

    })
    radarData[0]["store"] = 100
    radarData[1]["store"] = 100
    radarData[2]["store"] = 100
    radarData[3]["store"] = 100
    radarData[4]["store"] = 100

    // eslint-disable-next-line
  }, [data, dataStore])

  const CustomTooltip = ({ active, payload, label }) => {

    if (active) {
      return (
        <div className="custom-tooltip">
          <Typography
            variant='h1' component='h1'
            classes={{ h1: classes.avatar_text }}>
            {`${label}`}
          </Typography>
          {payload.map((inf, index) => {
            if (inf.name === "Loja") {
              return null
            }
            if (Number(inf.value - 100).toFixed(2) >= 0) {
              return (
                <Typography
                  key={index}
                  variant='h1' component='h1'
                  classes={{ h1: classes.avatar_text }}>
                  {`${inf.name} : média da loja + ${Number(inf.value - 100).toFixed(2)}%.`}
                </Typography>
              )
            }
            else {
              return (
                <Typography
                  key={index}
                  variant='h1' component='h1'
                  classes={{ h1: classes.avatar_text }}>
                  {`${inf.name} : média da loja ${Number(inf.value - 100).toFixed(2)}%.`}
                </Typography>
              )
            }
          })}
        </div>
      );
    }
    return null;
  };
  return (
    <div className={classesMain.root}>
      <CssBaseline />
      <TopBar hideStore={true} />
      <DrawerMenu />
      <main className={classesMain.content}>
        <div className={classesMain.appBarSpacer} />
        <Container maxWidth="lg" className={classesMain.container}>
          <Grid container spacing={5} justifyContent={"flex-start"} direction="row">
            <Grid item xs={12} md={12} lg={12}>
              <Title><TrendingUpIcon /> Raio-x</Title>
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
              <Grid container spacing={3} alignItems={"flex-start"} justifyContent={"center"} direction="row">
                {data.map((seller) => {
                  return (
                    <Grid item key={seller.id}>
                      <Paper className={classesMain.paper}>
                        {/* <Grid container alignItems={"flex-start"} spacing={3} justify="center" direction="row"> */}
                        <Grid item xs={12} md={12} lg={12}>
                          <Item img_url={seller.img_url} style={classes.avatar_image} />
                        </Grid>
                        <Typography
                          variant='h1' component='h1'
                          classes={{ h1: classes.avatar_text }}>
                          {seller.name}
                        </Typography>
                      </Paper >
                    </Grid>
                  )
                })}
              </Grid>
            </Grid>
            <Grid item xs={12} md={12} lg={6}>
              <Paper className={classesMain.paper}>
                <Grid container spacing={3} justifyContent={"center"} direction="row">
                  <Grid item xs={12} md={2} lg={1}>
                    <Tooltip title="Compare seus vendedores entre eles e com a média da loja no período!">
                      <IconButton aria-label="Selecionar" size="large">
                        <InfoIcon />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                  <Grid item xs={12} md={10} lg={11}>
                    <Title>Radar</Title>
                  </Grid>
                </Grid>
                <RadarChart width={500} height={400} data={radarData}>
                  <PolarGrid />
                  <PolarAngleAxis dataKey="subject" name="name" />
                  <PolarRadiusAxis hide={true} domain={[0, 400]} />
                  <Radar name="Loja" dataKey="store" stroke="#02023c" fill="#02023c" fillOpacity={0.6} />
                  {data.map((seller, index) => {
                    let color
                    if (index === 0) {
                      color = indigo[50]
                    }
                    else if (index === 1) {
                      color = pink[50]
                    }
                    else {
                      if (index % 2 === 0) {
                        color = pink[100 * index / 2]
                      }
                      else {
                        color = indigo[parseInt((index - 1) * 50)]
                      }
                    }

                    return (
                      <Radar name={seller.name} key={seller.id} dataKey={seller.id} stroke={color} fill={color} fillOpacity={0.6} />
                    )
                  })}
                  <TooltipRecharts content={<CustomTooltip />} />
                  <Legend />
                </RadarChart>
              </Paper >
            </Grid>
            <Grid item xs={12} md={12} lg={6}>
              <Paper className={classesMain.paper}>
                <Grid container spacing={3} justifyContent={"center"} direction="row">
                  <Grid item xs={12} md={2} lg={1}>
                    <Tooltip title="Compare seus vendedores entre eles no período!">
                      <IconButton aria-label="Selecionar" size="large">
                        <InfoIcon />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                  <Grid item xs={12} md={10} lg={11}>
                    <Title>Performance</Title>
                  </Grid>
                </Grid>
                <ScatterChart
                  width={500}
                  height={400}
                  margin={{
                    top: 20, right: 20, bottom: 20, left: 20,
                  }}
                >
                  <CartesianGrid />
                  <XAxis type="number" dataKey="attendance" label={
                    <Label
                      angle={0}
                      position="bottom"
                      value="Atendimentos"
                    />
                  }
                    name="Atendimentos" domain={[0, 'dataMax + 15']} />
                  <YAxis type="number" dataKey="conversion" label={
                    <Label
                      angle={270}
                      position="left"
                      value="Conversão"
                    />}
                    name="Conversão" unit="%" domain={[0, dataMax => ((dataMax + 30 >= 100) ? 130 : dataMax + 30)]} />
                  <TooltipRecharts cursor={{ strokeDasharray: '3 3' }} />
                  <Scatter name="" data={data} fill="#8884d8">
                    <LabelList dataKey="name" position="top" />
                  </Scatter>
                </ScatterChart>
              </Paper>
            </Grid>
          </Grid>
        </Container>
        <Box pt={4} justify={"center"} alignItems={"center"}>
          <Copyright />
        </Box>
      </main>
    </div>
  );
}